import HcpButtonInterstitial from '../../components/button-interstitial';
import Button from '../button';
import './_util-nav.scss';

function HcpUtilNav() {
  return (
    <div className="hcp-util-nav">
      <div className="container">
        <span className='text-hcp-almost-black mr-auto'>
          THIS WEBSITE IS INTENDED FOR US HEALTHCARE PROFESSIONALS ONLY.
        </span>
        <Button
          customClass="hcp-util-nav__signup-link"
          buttonUrl="/hcp/keep-in-touch"
          data-gtm-event-name="Header"
          data-gtm-event-category="Navigation"
          data-gtm-event-action="Click"
          data-gtm-event-label="Keep in Touch"
        >Keep in Touch</Button>

        <HcpButtonInterstitial
          customClass="hcp-util-nav__patient-link"
          buttonUrl="/"
          variant="anchorlink"
          data-gtm-event-name="Header"
          data-gtm-event-category="Navigation"
          data-gtm-event-action="Click"
          data-gtm-event-label="Patient Site"
        ><span className="underline text-hcp-almost-black">Patient Site</span></HcpButtonInterstitial>
      </div>
    </div>    
  );
}

export default HcpUtilNav;